import React from "react";
import PropTypes from "prop-types";
import { Bar } from "@reactchartjs/react-chart.js";
import Text from "antd/es/typography/Text";
import {Spin} from "antd";

const EnrolmentBarChart = ({ data, options, title }) => {
    if(data.datasets.length > 0) {
        return (
            <div>
                <Text strong="true">{title}</Text>
                <Bar data={data} options={options} />
            </div>
        );
    } return (
        <Spin />
    )

};

EnrolmentBarChart.propTypes = {
  data: PropTypes.array.isRequired,
  options: PropTypes.object,
  title: PropTypes.string,
};

export default EnrolmentBarChart;
